import React from 'react';
import ApiFetch from "../components/ApiFetch";
export async function getOdai(){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/latest").then((r)=>r.json().then((json)=>{
        return json
    }))
}